import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import Logo from "@/components/Logo";

const field = "bg-[#121212] border-white/20 rounded-none text-white focus-visible:ring-1 focus-visible:ring-[#ff5a00] focus-visible:border-[#ff5a00]";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Kirjautuminen onnistui");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Kirjautuminen epäonnistui");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-10"><Logo /></div>
        <h1 className="font-display text-3xl tracking-tight text-center mb-8">Ylläpito</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <Input required type="email" placeholder="Sähköposti" value={email} onChange={(e) => setEmail(e.target.value)} className={field} data-testid="login-email" />
          <Input required type="password" placeholder="Salasana" value={password} onChange={(e) => setPassword(e.target.value)} className={field} data-testid="login-password" />
          <button type="submit" disabled={busy} data-testid="login-submit"
            className="w-full bg-[#ff5a00] text-white font-mono text-xs uppercase tracking-widest px-8 py-4 hover:bg-white hover:text-black transition-colors duration-300 disabled:opacity-50">
            {busy ? "Kirjaudutaan…" : "Kirjaudu"}
          </button>
        </form>
      </div>
    </div>
  );
}
